import type { QuestionRoutingRule } from "./draft.generated";

/**
 * A route's closed vocabularies, read from the draft contract's own union
 * (`QuestionRoutingRule`, generated from the Pydantic owner): each list is
 * written as a record over that union, so a member added to the contract and
 * not here fails to compile. The validator's `routingRuleIssues` and the
 * accepted-artifact gate read these, never their own literals (wave H L7,
 * `invalid_routing_rule`).
 */
function members<T extends string>(record: Record<T, true>): ReadonlyArray<T> {
  return Object.keys(record) as Array<T>;
}

export const ROUTING_ACTIONS = members<QuestionRoutingRule["action"]>({ skip_to: true, end_survey: true });
export const ROUTING_SCOPES = members<NonNullable<QuestionRoutingRule["scope"]>>({ respondent: true, session: true });
export const ROUTING_DISPOSITIONS = members<NonNullable<QuestionRoutingRule["disposition"]>>({
  branch_complete: true,
  screened_out: true,
});
